module.exports = __webpack_public_path__ + "static/media/prescriptions@2x.52262f27.png";